import { render, staticRenderFns } from "./AddTheoryPracticeWorkshopLessonTheoryModal.vue?vue&type=template&id=5f02e115&scoped=true&"
import script from "./AddTheoryPracticeWorkshopLessonTheoryModal.vue?vue&type=script&lang=js&"
export * from "./AddTheoryPracticeWorkshopLessonTheoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTheoryPracticeWorkshopLessonTheoryModal.vue?vue&type=style&index=0&id=5f02e115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02e115",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VContainer,VDialog,VRow,VSpacer})
